import Bus from "./bus";

export type ToastCategory = "standard" | "info" | "success" | "warning" | "error";

export interface ToastOptions {
    title?: string;
    duration?: number;
}

function emit(
    categoryName: ToastCategory,
    message: string,
    { title, duration }: ToastOptions = {}
) {
    Bus.emit("notification", {
        title: title ?? defaultTitle(categoryName),
        message,
        categoryName,
        duration: duration ?? 4500,
    });
}

function defaultTitle(cat: ToastCategory) {
    switch (cat) {
        case "success":
            return "Erfolg";
        case "error":
            return "Fehler";
        case "warning":
            return "Achtung";
        case "info":
            return "Info";
        default:
            return "Hinweis";
    }
}

export const Toast = {
    show: (message: string, opts?: ToastOptions) => emit("standard", message, opts),
    info: (message: string, opts?: ToastOptions) => emit("info", message, opts),
    success: (message: string, opts?: ToastOptions) => emit("success", message, opts),
    warning: (message: string, opts?: ToastOptions) => emit("warning", message, opts),
    error: (message: string, opts?: ToastOptions) => emit("error", message, opts),
};
